import { readStoredJson, removeStoredKey, writeStoredJson } from '../../lib/storage';
import { KEYPAD_STORAGE_KEY } from './catalog/storage';
import { decodeBook } from './decode';
import type { KeypadBook } from './model';
import { createEmptyBook } from './model';

/**
 * The keypad book lives only on this tablet, beside — but separate from — the RCU
 * configuration. If storage is unavailable the feature still runs from memory, so
 * nothing here is authoritative.
 */
export const loadStoredBook = (now: string): KeypadBook => {
  const raw = readStoredJson(KEYPAD_STORAGE_KEY);
  if (raw === null) return createEmptyBook(now);

  const decoded = decodeBook(raw);
  if (decoded === null) {
    console.warn('Keypads: stored panels were not readable and have been ignored.');
    return createEmptyBook(now);
  }
  if (decoded.droppedRecords > 0) {
    console.warn(`Keypads: ignored ${decoded.droppedRecords} unreadable panel record(s).`);
  }
  return decoded.book;
};

export const saveStoredBook = (book: KeypadBook): void => {
  writeStoredJson(KEYPAD_STORAGE_KEY, book);
};

export const clearStoredBook = (): void => {
  removeStoredKey(KEYPAD_STORAGE_KEY);
};
